<template>
  <section class="activity-wrapper">
    <!-- 分期信息 -->
    <installment-info
      v-if="dataInfo.installmentInfo"
      :installmentInfo="dataInfo.installmentInfo"
      @listenFold="listenFold"
    ></installment-info>

    <!-- 配送地址栏 -->
    <delivery-info
      v-if="dataInfo.deliveryInfo && dataInfo.deliveryInfo.sendAddress"
      :deliveryInfo="dataInfo.deliveryInfo"
      :dataInfo="dataInfo"
    />
    <!-- 退货包邮 -->
    <div v-if="Object.values(afterSalesService).length && afterSalesService.activityTitle">
      <new-common-banner
        title=""
        icon="https://pic2.zhuanstatic.com/zhuanzh/d847803c-9e2e-4687-b639-651c580cde57.png"
        @ensureClick="$refs.salesReturn.PopupReturnShow = true"
      >
        <div class="process-item">
          <div class="item_address">
            <span class="title">保障</span>
          </div>
          <div class="item_info">{{ afterSalesService.activityTitle }}</div>
        </div>
      </new-common-banner>
      <sales-return-popup ref="salesReturn" :dataInfo="dataInfo" />
    </div>
    <!-- 活动 -->
    <activity-info
      v-if="dataInfo.titleBottomInfoList"
      :titleBottomInfo="dataInfo.titleBottomInfoList"
    ></activity-info>

    <!-- 以旧换新腰带组件 -->
    <!-- <old2new-card
      v-if="!getQueryString('saleCombineIds')"
      ref="oldRef"
      class="old-to-new hidden"
      type="ZZ"
      sectionId="139"
      :productId="state.infoId"
      :metric="state.metric"
      pageId="T2974"
      :cateId="dataInfo.cateLastId"
      @complete="completeHandle"
    /> -->
    <!-- 小程序租机入口 -->
    <lease-info v-if="inWa" :leaseInfo="dataInfo.leaseVo" />
  </section>
</template>
<script>
import { defineComponent, onMounted, computed, ref } from '@vue/composition-api'
import { isPlatform } from '@utils/native'
import deliveryInfo from './delivery-info.vue' // 配送信息
import installmentInfo from './installmentInfo.vue'
import activityInfo from './activity-info.vue'
import leaseInfo from './lease-info.vue'
// import { Old2newCard } from '@zz-yp/bm-ui'
import '@zz-yp/bm-ui/lib/old2new-card/style/index'
import SalesReturnPopup from './sales-return-popup.vue'
import { state } from '@/store/index'
import newCommonBanner from '@/components/new-common-banner.vue'
import { getQueryString } from '@utils/index'
// Vue.use(Old2newCard)
export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    deliveryInfo,
    installmentInfo,
    activityInfo,
    SalesReturnPopup,
    newCommonBanner,
    leaseInfo
  },
  setup(props, ctx) {
    const { $tiktok, $legoAreaExposure } = ctx.root
    const foldStatus = ref(true)
    const addressInfo = ref({})
    const testGroupName = ref('')
    const inWa = ref(false)
    inWa.value = isPlatform('wa')
    $tiktok('create', 'activityInfo')
    onMounted(() => {
      $tiktok('mounted', 'new-activity-info')
      ctx.emit('cmpMounted')
      $legoAreaExposure()
    })
    const installmentDetails = computed(() => {
      return props.dataInfo.installmentInfo?.installmentDetails || []
    })
    const listenFold = (data) => {
      foldStatus.value = data
    }
    // const completeHandle = (info) => {
    //   const { addressInformation, btnInfo, testGroup, cardInfo } = info || {}
    //   addressInfo.value = addressInformation
    //   testGroupName.value = testGroup
    //   setState({
    //     btnInfo,
    //     addressInformation,
    //     testGroup
    //   })
    //   if (addressInformation && !cardInfo) {
    //     $legoSend('Areaexposure', {
    //       sectionId: 139,
    //       sortId: 0,
    //       sortName: '以旧换新腰带组件(不显示)',
    //       ...addressInfo.value,
    //       isShow: false
    //     })
    //   }
    // }
    const afterSalesService = computed(() => {
      const afterSalesService = props.dataInfo.afterSalesService || {}
      return afterSalesService
    })
    return {
      inWa,
      installmentDetails,
      foldStatus,
      listenFold,
      // completeHandle,
      state,
      addressInfo,
      testGroupName,
      afterSalesService,
      getQueryString
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/animation.scss';

.activity-wrapper {
  margin-bottom: 38px;
  padding: 0 32px;
  color: #111;
  font-weight: 400;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 24px;
  background: #ffffff;

  .fold {
    margin: 22px 0 -22px 80px;
  }

  .unfold {
    margin: 22px 0 22px 80px;
  }

  // .old-to-new {
  //   margin-top: 40px;
  //   &.hidden {
  //     display: none;
  //   }
  // }
}
</style>
